module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-flex'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "20",
      "solo": ""
    },
    model: {
      value: (_vm.raw),
      callback: function($$v) {
        _vm.raw = $$v
      },
      expression: "raw"
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.clients.length) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_vm._v("\n              Current client count\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.items.length) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_vm._v("\n              About to add\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.getClients()
      }
    }
  }, [_vm._v("Reload clients")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.createAll
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('client-list', {
    staticClass: "mt-3"
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs1": ""
      }
    }, [(_vm.getRequest(item).loading) ? _c('v-progress-circular', {
      staticClass: "mt-2",
      attrs: {
        "color": "amber",
        "size": 30,
        "indeterminate": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getRequest(item).status === 201) ? _c('v-icon', {
      staticClass: "mt-3",
      attrs: {
        "color": "green"
      }
    }, [_vm._v("check_cirle")]) : _vm._e(), _vm._v(" "), (_vm.getRequest(item).status > 299) ? _c('v-icon', {
      staticClass: "mt-3",
      attrs: {
        "color": "red"
      }
    }, [_vm._v("warning")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "full name"
      },
      model: {
        value: (item.full_name),
        callback: function($$v) {
          _vm.$set(item, "full_name", $$v)
        },
        expression: "item.full_name"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "phone"
      },
      model: {
        value: (item.phone_number),
        callback: function($$v) {
          _vm.$set(item, "phone_number", $$v)
        },
        expression: "item.phone_number"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "email"
      },
      model: {
        value: (item.email),
        callback: function($$v) {
          _vm.$set(item, "email", $$v)
        },
        expression: "item.email"
      }
    })], 1)], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ef199aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/BulkAdd.vue
// module id = 1648
// module chunks = 1